// ---------- COLOR HELPERS (ported from prototype) ----------

export function lum(hex: string): number {
	const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
	if (!m) return 0;
	const n = parseInt(m[1], 16);
	const r = ((n >> 16) & 255) / 255;
	const g = ((n >> 8) & 255) / 255;
	const b = (n & 255) / 255;
	const f = (c: number) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
	return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}

/** Returns accessible foreground for a given background hex. */
export function ctext(hex: string): string {
	return lum(hex) > 0.55 ? "#1f2937" : "#ffffff";
}

/** Darkens hex by factor f (0–1). */
export function shade(hex: string, f: number): string {
	const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
	if (!m) return hex;
	const n = parseInt(m[1], 16);
	let r = (n >> 16) & 255;
	let g = (n >> 8) & 255;
	let b = n & 255;
	r = Math.round(r * (1 - f));
	g = Math.round(g * (1 - f));
	b = Math.round(b * (1 - f));
	return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
